function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 21,
    viewBox: "0 0 51 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Pay with Apple Pay",
    style: {
      opacity: 0.296
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Controls/Buttons/Apple-Pay/Pay-with-\\uF8FFPay/White"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Controls/Buttons/Apple-Pay/x/Pay-with-\\uF8FFPay/Black"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uF8FFPay",
    d: "M10.627-14.588a3.781 3.781 0 0 0 .913-2.369 1.588 1.588 0 0 0-.033-.338 3.862 3.862 0 0 0-2.538 1.288 3.653 3.653 0 0 0-.946 2.292 1.471 1.471 0 0 0 .033.306 1.3 1.3 0 0 0 .234.022 3.4 3.4 0 0 0 2.337-1.201zm.613 1.388c-1.3 0-2.36.775-3.038.775-.723 0-1.669-.731-2.8-.731-2.148 0-4.33 1.746-4.33 5.032a10.231 10.231 0 0 0 1.8 5.61c.857 1.179 1.6 2.15 2.682 2.15s1.536-.7 2.86-.7c1.347 0 1.647.677 2.827.677s1.948-1.048 2.682-2.085a8.937 8.937 0 0 0 1.18-2.4A3.752 3.752 0 0 1 12.8-8.3a3.817 3.817 0 0 1 1.859-3.22 4.087 4.087 0 0 0-3.419-1.68zM16.65-.486h2.872v-5.207h3.539c3.261 0 5.465-2.117 5.465-5.261v-.022c0-3.154-2.2-5.261-5.465-5.261H16.65zm5.71-13.447c2.059 0 3.261 1.081 3.261 2.969v.022c0 1.888-1.2 2.98-3.261 2.98h-2.839v-5.97zM33.056-.29a3.935 3.935 0 0 0 3.562-1.834h.189v1.638h2.738V-8.64c0-2.521-1.759-4.006-4.886-4.006-2.894 0-4.853 1.332-5.12 3.34l-.011.1h2.616l.011-.044c.278-.786 1.1-1.233 2.371-1.233 1.491 0 2.282.655 2.282 1.845v1.026l-3.128.186c-2.961.175-4.619 1.419-4.619 3.547v.022c-.001 2.17 1.68 3.567 3.995 3.567zM31.8-3.99v-.022c0-.982.723-1.539 2.271-1.637l2.738-.175v.96a2.653 2.653 0 0 1-2.9 2.489c-1.231.001-2.109-.6-2.109-1.615zm10.773 7.695c2.693 0 4.085-.95 5.131-3.94l4.363-12.181h-2.916l-2.827 9.321h-.211l-2.838-9.321h-3.028L44.6-.475l-.146.545a1.926 1.926 0 0 1-2.115 1.539c-.289 0-.6-.011-.824-.033v2.085c.335.033.724.044 1.058.044z",
    transform: "translate(-1.068 17.295)",
    style: {
      fill: "#404041"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePayIcon);
export default __webpack_public_path__ + "static/media/apple-pay-icon.becc95fa.svg";
export { ForwardRef as ReactComponent };